module.exports = __webpack_public_path__ + "static/media/card.bf62440a.svg";